import React, { useState } from "react";
import { FaX, FaList, FaCrosshairs } from "react-icons/fa6";
import PopupWindow from "components/PopupWindow";
import LoginMenu from "pages/Login/LoginMenu";
import DeviceList from "components/DeviceList";
import FullScreenMap from "components/FullscreenMap";
import LocationSetter from "components/LocationSetter";
import InfoButton from "components/InfoButton";
import DeviceMarker from "./DeviceMarker";
import { UserMenu, UserButton } from "./UserMenu";
import { TermsOfUseModal, PrivacyPolicyModal } from "./PolicyModals";
import logoDark from "assets/Overwatch_App_Logo_By_RescAlert_TM.png";
import { PiTarget } from "react-icons/pi";

const MobileView = ({
  // Auth & User related
  loginPopupOpen,
  setLoginPopupOpen,
  showUserMenu,
  setShowUserMenu,
  auth,
  handleLogout,
  error,
  setError,
  success,
  setSuccess,

  // Device List related
  showMobileDevices,
  setShowMobileDevices,
  showSettingsState,
  setShowSettingsState,
  groupedDevices,
  toggleCategoryCollapse,
  collapsedCategories,
  toggleGroupCollapse,
  collapsedGroups,
  listSelect,
  setListSelect,
  setMapCenter,
  setMapZoom,
  getBasicDeviceIcon,
  selectedDevices,
  toggleDevice,
  triggerLoginOpen,
  handleSave,

  // Map related
  _initialMapCenter,
  _initialMapZoom,
  mapCenter,
  mapZoom,
  setCalcZoom,
  setCalcCenter,
  displayData,
  calcZoom,
  deviceTypeToCategory,
  popupOpen,
  setPopupOpen,
  saveSuccess,

  // Data related
  data,

  // Modal related
  showTermsOfUse,
  setShowTermsOfUse,
  showPrivacyPolicy,
  setShowPrivacyPolicy,

  // Exploded groups
  explodedGroups,
  setExplodedGroups,
  toggleGroupExploded,
  calculateBounds,
  setMultipleGroupsCollapse,
}) => {
  const [filter, setFilter] = useState("");
  const [shouldResetFilter, setShouldResetFilter] = useState(false);

  const [selectedGroup, setSelectedGroup] = useState(null);
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      {/* Login Popup */}
      {loginPopupOpen && (
        <PopupWindow
          setOpen={setLoginPopupOpen}
          open={loginPopupOpen}
          style={{
            background: "#ffffff",
            color: "black",
          }}
        >
          <LoginMenu
            callback={(response) => {
              console.log("Callback from LoginMenu:", response);
              if (response.success) {
                setSuccess(response.message);
                setError("");
                setTimeout(() => {
                  setSuccess("");
                  setError("");
                }, 10000);
              } else if (!response.success) {
                setSuccess("");
                setError(response.error);
              }
              setLoginPopupOpen(false);
            }}
            setError={(error) => {
              setError(error?.message || error);
              setSuccess("");
            }}
          />
          {error && (
            <p style={{ color: "red", textAlign: "center" }}>{error}</p>
          )}
          {success && (
            <p
              style={{
                color: "#436c9a",
                textAlign: "center",
              }}
            >
              {success}
            </p>
          )}
        </PopupWindow>
      )}

      {/* User Menu */}
      <UserMenu
        showUserMenu={showUserMenu}
        auth={auth.auth}
        handleLogout={handleLogout}
      />

      {/* Header with logo and user button */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          margin: "0 0 20px 0",
          height: "60px",
          position: "absolute",
          top: 10,
          left: 0,
          right: 0,
          zIndex: 10,
          pointerEvents: "none", // Allow clicking through to map
        }}
      >
        <img
          src={logoDark}
          alt="logo"
          style={{
            height: "100%",
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            pointerEvents: "auto", // Enable clicks on logo
          }}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            position: "absolute",
            right: 20,
            top: 10,
            pointerEvents: "auto", // Enable clicks on user button container
          }}
        >
          <UserButton
            auth={auth.auth}
            showUserMenu={showUserMenu}
            setShowUserMenu={setShowUserMenu}
            setLoginPopupOpen={setLoginPopupOpen}
            setLoginMode={() => {}}
          />
        </div>
      </div>

      {/* Device selection dropdown */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          margin: "0 0 20px 0",
          height: "60px",
          position: "absolute",
          top: 80,
          left: 0,
          right: 0,
          zIndex: 5,
        }}
      >
        {/* <select
          style={{
            background: "white",
            borderRadius: 10,
            padding: 8,
            boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
            cursor: "pointer",
            border: "none",
            fontSize: 20,
            marginLeft: 20,
            width: "100%",
            marginRight: 20,
          }}
          onChange={(e) => {
            if (e.target.value === "null") {
              return;
            }

            const deviceId = e.target.value;
            console.log("Selected device ID:", deviceId);

            let selectedDevice = null;
            Object.keys(data).forEach((county) => {
              if (data[county][deviceId]) {
                selectedDevice = data[county][deviceId];
              }
            });

            console.log("Found device:", selectedDevice);
            if (selectedDevice) {
              setMapCenter(JSON.parse(selectedDevice.location));
            }
          }}
        >
          <option value="null">Select a device</option>
          {Object.keys(data).flatMap((county) =>
            Object.values(data[county]).map((device) => (
              <option key={device.id} value={device.id}>
                {device.node_id} - {device.alias}
              </option>
            ))
          )}
        </select> */}
        <div />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginRight: 20,
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: 50,
              padding: 8,
              boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
              cursor: "pointer",
            }}
            onClick={() => {
              setShowMobileDevices(!showMobileDevices);
            }}
          >
            <FaList
              size={30}
              style={{
                color: "#002a52",
              }}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          margin: "0 0 20px 0",
          height: "60px",
          position: "absolute",
          top: 150,
          left: 0,
          right: 0,
          zIndex: 1,
        }}
      >
        {/* <select
          style={{
            background: "white",
            borderRadius: 10,
            padding: 8,
            boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
            cursor: "pointer",
            border: "none",
            fontSize: 20,
            marginLeft: 20,
            width: "100%",
            marginRight: 20,
          }}
          onChange={(e) => {
            if (e.target.value === "null") {
              return;
            }

            const deviceId = e.target.value;
            console.log("Selected device ID:", deviceId);

            let selectedDevice = null;
            Object.keys(data).forEach((county) => {
              if (data[county][deviceId]) {
                selectedDevice = data[county][deviceId];
              }
            });

            console.log("Found device:", selectedDevice);
            if (selectedDevice) {
              setMapCenter(JSON.parse(selectedDevice.location));
            }
          }}
        >
          <option value="null">Select a device</option>
          {Object.keys(data).flatMap((county) =>
            Object.values(data[county]).map((device) => (
              <option key={device.id} value={device.id}>
                {device.node_id} - {device.alias}
              </option>
            ))
          )}
        </select> */}
        <div />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginRight: 20,
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: 50,
              padding: 8,
              boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
              cursor: "pointer",
            }}
            onClick={() => {
              setMapCenter(_initialMapCenter);
              setMapZoom(_initialMapZoom);
            }}
          >
            <FaCrosshairs
              size={30}
              style={{
                color: "#002a52",
              }}
            />
          </div>
        </div>
      </div>
      {/* Map */}
      <FullScreenMap
        mapCenter={_initialMapCenter}
        zoom={_initialMapZoom}
        minZoom={6}
        maxZoom={18}
        onZoomEnd={(zoom) => {
          if (shouldResetFilter) {
            setSelectedGroup(null); // Reset selected group on zoom end
            setMultipleGroupsCollapse(
              Object.keys(collapsedGroups).reduce((acc, key) => {
                acc[key] = true; // Collapse all groups
                return acc;
              }, {})
            );
          }
          setCalcZoom(zoom);
        }}
        onMoveEnd={(center) => setCalcCenter(center)}
      >
        <LocationSetter center={mapCenter} zoom={mapZoom} />
        {/* Replace displayData mapping with groupedDevices mapping */}
        {Object.keys(groupedDevices).map((category) =>
          groupedDevices[category].map((group) => (
            <DeviceMarker
              key={`${category}-${group.id}`}
              group={group}
              category={category}
              mapZoom={mapZoom}
              calcZoom={calcZoom}
              deviceTypeToCategory={deviceTypeToCategory}
              auth={{ auth: { email: "desktop" } }}
              triggerLoginOpen={triggerLoginOpen}
              setMapCenter={setMapCenter}
              setMapZoom={setMapZoom}
              setCalcZoom={setCalcZoom}
              popupOpen={popupOpen}
              setPopupOpen={setPopupOpen}
              listSelect={listSelect}
              selectedDevices={selectedDevices}
              toggleDevice={toggleDevice}
              saveSuccess={saveSuccess}
              handleSave={handleSave}
              setLoginPopupOpen={setLoginPopupOpen}
              collapsedGroups={collapsedGroups}
              toggleGroupCollapse={toggleGroupCollapse}
              calculateBounds={calculateBounds}
              groupedDevices={groupedDevices}
              setMultipleGroupsCollapse={setMultipleGroupsCollapse}
              filter={filter}
              setFilter={setFilter}
              setShowMobileDevices={setShowMobileDevices}
              setSelectedGroup={setSelectedGroup}
              setShouldResetFilter={setShouldResetFilter}
            />
          ))
        )}
      </FullScreenMap>

      {/* Policy section */}
      <div
        style={{
          width: "50%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "absolute",
          left: 10,
          bottom: 10,
          right: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 5,
          }}
        >
          <div
            style={{
              padding: 10,
              borderRadius: 100,
              background: "#436c9a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 10,
              cursor: "pointer",
            }}
            onClick={() => {
              setShowPrivacyPolicy(true);
            }}
          >
            Privacy & Cookie Policy
          </div>
        </div>
      </div>

      {/* Mobile device list */}
      {showMobileDevices && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            position: "absolute",
            top: 150,
            maxHeight: "70vh",
            height: "70vh",
            maxWidth: "90vw",
            width: "90vw",
            overflow: "auto",
            background: "#1e374f",
            zIndex: 1,
            boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
          }}
        >
          <div
            style={{
              padding: "15px",
              display: "flex",
              flexDirection: "column",
              overflowY: "auto",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  fontSize: 18,
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "center",
                  textAlign: "center",
                  color: "white",
                }}
              >
                {showSettingsState ? "Device Subscriptions" : "Device List"}
              </div>
              <div
                style={{
                  justifyContent: "flex-end",
                  display: "flex",
                  marginRight: 15,
                }}
                onMouseDown={() => {
                  setShowMobileDevices(false);
                  setShowSettingsState(false);
                }}
              >
                <FaX size={20} color={"white"} />
              </div>
            </div>
            <DeviceList
              showSettingsState={showSettingsState}
              setShowSettingsState={setShowSettingsState}
              setLoginPopupOpen={setLoginPopupOpen}
              triggerLoginOpen={triggerLoginOpen}
              handleSave={handleSave}
              saveSuccess={saveSuccess}
              groupedDevices={groupedDevices}
              toggleCategoryCollapse={toggleCategoryCollapse}
              collapsedCategories={collapsedCategories}
              toggleGroupCollapse={toggleGroupCollapse}
              collapsedGroups={collapsedGroups}
              listSelect={listSelect}
              setListSelect={setListSelect}
              setMapCenter={setMapCenter}
              setMapZoom={setMapZoom}
              getBasicDeviceIcon={getBasicDeviceIcon}
              selectedDevices={selectedDevices}
              toggleDevice={toggleDevice}
              calculateBounds={calculateBounds}
              setCalcZoom={setCalcZoom}
              filter={filter}
              setFilter={setFilter}
              selectedGroup={selectedGroup}
              setSelectedGroup={setSelectedGroup}
              setShouldResetFilter={setShouldResetFilter}
            />
          </div>
        </div>
      )}

      {/* Info button */}
      <div
        style={{
          position: "absolute",
          right: 10,
          bottom: 10,
        }}
      >
        <InfoButton />
      </div>

      {/* Modals */}
      <TermsOfUseModal
        showTermsOfUse={showTermsOfUse}
        setShowTermsOfUse={setShowTermsOfUse}
        handleLogout={handleLogout}
      />

      <PrivacyPolicyModal
        showPrivacyPolicy={showPrivacyPolicy}
        setShowPrivacyPolicy={setShowPrivacyPolicy}
        handleLogout={handleLogout}
        setShowTermsOfUse={setShowTermsOfUse}
      />
    </div>
  );
};

export default MobileView;
